import styled from "styled-components";
import { Color, Radius, ZIndexes } from "@glossy";

function getXOffset(x: number, width: number, tooltipWidth: number) {
  const halfWidth = tooltipWidth / 2;
  if (x - halfWidth < 0) {
    return -halfWidth + (halfWidth - x);
  } else if (x + halfWidth > width) {
    return -halfWidth - (x + halfWidth - width);
  } else {
    return -halfWidth;
  }
}

function getYOffset(y: number, height: number, tooltipHeight: number) {
  if (y + tooltipHeight + 32 > height) {
    return -tooltipHeight - 32;
  } else {
    return 32;
  }
}

function canDisplayArrow(
  x: number,
  width: number,
  tooltipWidth: number,
  y: number,
  height: number,
  tooltipHeight: number
) {
  if (x !== null && y !== null) {
    const halfWidth = tooltipWidth / 2;
    if (x - halfWidth < 0 || x + halfWidth > width) {
      return false;
    } else if (y + tooltipHeight + 32 > height) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export default styled.div<{
  x: number;
  y: number;
  width: number;
  height: number;
  tooltipWidth: number;
  tooltipHeight: number;
}>`
  position: absolute;
  border-radius: ${Radius.Medium};
  max-width: 300px;
  pointer-events: none;
  color: ${Color.White};
  background: ${Color.BlackPearl};
  z-index: ${ZIndexes.Tooltips};
  top: ${(props) => getYOffset(props.y, props.height, props.tooltipHeight)}px;
  left: ${(props) => getXOffset(props.x, props.width, props.tooltipWidth)}px;
  &:after {
    content: "";
    display: ${(props) =>
      canDisplayArrow(
        props.x,
        props.width,
        props.tooltipWidth,
        props.y,
        props.height,
        props.tooltipHeight
      )
        ? "block"
        : "none"};
    border-bottom: 5px solid ${Color.BlackPearl};
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    position: absolute;
    bottom: 100%;
    left: calc(50% - 5px);
  }
`;
